import parse from "html-react-parser";
import {isNotEmpty} from "../../utils/strings";
import CustomInput from "../form/CustomInput";
import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import "../../../style/common/goodslist/_search_box.scss";
import useAuth from "../../auth/useAuth";

const SearchBoxView = (
  {
    data = ""
  }) => {
  const [keywords, setKeywords] = useState("");
  const navigate = useNavigate();
  const { authed } = useAuth();


  /**
   * 検索ボタンクリック
   */
  const handleSearch = () => {
    navigate("/list/?k=" + keywords)
  }

  return (!authed) ?
    <></>
    :
    (
    <div className="ps-2 pe-2" style={data["style"]}>
      {isNotEmpty(data.css) && <style>{parse(data.css)}</style>}
      <div className={"row comSearch footerSearch " + data["attr"]["className"]}>
        <div className="col-12">
          <div className="comSearchInner">
            <div className="row">
              <div className="col-12 col-md-auto mb-2 me-4 mb-md-0 text-center text-md-start">
                <div className="headLine01">Item Search</div>
                <div className="headLine02">商品検索</div>
              </div>
              <div className="col-12 col-md">
                <div className="row gx-0 gy-0 search-box">
                  <div className="input-group input-group-sm mb-3">
                    <CustomInput className="form-control border-0 rounded-0 keywords-input"
                                 name="keywords"
                                 value={keywords}
                                 type="search"
                                 placeholder="キーワードを入力してください"
                                 setValue={setKeywords}
                                 onEnterKey={handleSearch}
                    />
                    <button className="btn btn-secondary border-0 rounded-0 rounded-right btn-search "
                            onClick={handleSearch}
                            type="button">
                      <span>検索</span>
                      <i className="fa fa-search ms-2" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};
export default SearchBoxView;